import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { Reveal, SectionHeading } from "@/components/landing/primitives";
import { TOKENOMICS, TOKEN_FACTS } from "@/data/content";

export default function Tokenomics() {
  return (
    <section id="token" className="relative py-20 md:py-28 scroll-mt-24" data-testid="section-token">
      <div className="absolute inset-0 radial-gold opacity-60" />
      <div className="container-trt relative z-10">
        <SectionHeading
          eyebrow="Token & Ecosystem"
          title="The TRT token,"
          highlight="fairly distributed"
          sub="TRT powers gas, staking, governance and rewards across the ecosystem — with a fixed supply and transparent allocation."
        />

        <div className="mt-16 grid lg:grid-cols-2 gap-12 items-center">
          {/* Donut */}
          <Reveal>
            <div className="relative">
              <div className="absolute inset-0 blur-3xl opacity-25 rounded-full bg-[radial-gradient(circle,var(--gold-2),transparent_60%)]" />
              <div className="relative h-[340px]">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={TOKENOMICS}
                      dataKey="value"
                      nameKey="name"
                      innerRadius={78}
                      outerRadius={130}
                      paddingAngle={3}
                      stroke="none"
                    >
                      {TOKENOMICS.map((e, i) => (
                        <Cell key={i} fill={e.color} />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
                <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                  <div className="font-display text-3xl font-extrabold gold-text">11M</div>
                  <div className="text-xs font-mono text-[var(--muted)]">MAX SUPPLY</div>
                </div>
              </div>
            </div>
          </Reveal>

          {/* Legend + facts */}
          <div>
            <div className="grid gap-2.5">
              {TOKENOMICS.map((e, i) => (
                <Reveal key={e.name} delay={i * 0.06}>
                  <div className="flex items-center justify-between glass rounded-xl px-4 py-3 card-hover">
                    <div className="flex items-center gap-3">
                      <span className="w-3 h-3 rounded-sm" style={{ background: e.color }} />
                      <span className="text-sm font-medium">{e.name}</span>
                    </div>
                    <span className="font-mono font-semibold text-[var(--gold-2)]">{e.value}%</span>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.2}>
              <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-3">
                {TOKEN_FACTS.map((f) => (
                  <div key={f.k} className="glass-gold rounded-xl p-3 text-center">
                    <div className="text-[10px] font-mono uppercase tracking-wider text-[var(--muted)]">{f.k}</div>
                    <div className="mt-1 font-display font-bold text-sm">{f.v}</div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
